import type { FC} from "react";
import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import { useToastMessage } from '~/hooks'


export let Toaster: FC = () => {
    let toast = useToast()
    let toastMessage = useToastMessage()

    useEffect(() => {
    if (!toastMessage) {
      return;
    }

    toast({
      status: 'success',
      duration: 5000,
      isClosable: true,
      ...toastMessage
    })

    }, [toastMessage])

    return null
}

export default Toaster
